<se-tabbar color="primary" overflow="scroll">
  <nav>
    <a *ngFor="let item of items" [class.active]="isActive(item)" [title]="getItemTitle(item.title)" (click)="goToItem(item)">{{getItemTitle(item.title)}}</a>
  </nav>
</se-tabbar>
